// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatBackgroundPattern__container-a32a01 {
  background: var(--pattern-base);
  position: absolute;
  display: flex;
  align-items: stretch;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
}

.ChatBackgroundPattern__background-image-db51b4 {
  background: var(--pattern);
  background-attachment: fixed;
  background-position: top center;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/components/ChatBackground/ChatBackgroundPattern/ChatBackgroundPattern.styles.m.css"],"names":[],"mappings":"AAAA;EACE,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;AACF;;AAEA;EACE,0BAAA;EACA,4BAAA;EACA,+BAAA;EACA,WAAA;AACF","sourcesContent":[".container {\n  background: var(--pattern-base);\n  position: absolute;\n  display: flex;\n  align-items: stretch;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.background-image {\n  background: var(--pattern);\n  background-attachment: fixed;\n  background-position: top center;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChatBackgroundPattern__container-a32a01`,
	"background-image": `ChatBackgroundPattern__background-image-db51b4`,
	"backgroundImage": `ChatBackgroundPattern__background-image-db51b4`
};
module.exports = ___CSS_LOADER_EXPORT___;
